import modraKuchyn1 from "./img/modra/IMG_0645.JPG";
import modraKuchyn2 from "./img/modra/IMG_0648.JPG";
import modraKuchyn3 from "./img/modra/IMG_0644.JPG";
import modraKuchyn4 from "./img/modra/IMG_0648.JPG";
import hnedaKuchyn1 from "./img/hneda/IMG_2254.JPG";
import hnedaKuchyn2 from "./img/hneda/IMG_2255.JPG";

import kancelar from "./img/kancelar.JPG";

import pokoj from "./img/pokoje/pokoj.jpg";
import pokoj2 from "./img/pokoje/IMG_4236.JPG";
import pokoj3 from "./img/pokoje/IMG_4235.JPG";

import recepce from "./img/recepce.jpg";

import restaurace from "./img/restaurace.jpg";

import stolek from "./img/stolek.jpg";

export default [
  {
    sys: {
      id: "1"
    },
    fields: {
      name: "kuchyně Nováků",
      slug: "kuchyne-novaku",
      type: "kitchen",
      description:
        "Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Curabitur ligula sapien, pulvinar a vestibulum quis, facilisis vel sapien. Fusce wisi. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Etiam sapien elit, consequat eget, tristique non.",
      extras: ["realizace 2018", "použito lamino, masiv", "cena do 200 000 Kč"],
      images: [
        {
          fields: {
            file: {
              url: modraKuchyn1
            }
          }
        },
        {
          fields: {
            file: {
              url: modraKuchyn2
            }
          }
        },
        {
          fields: {
            file: {
              url: modraKuchyn3
            }
          }
        },
        {
          fields: {
            file: {
              url: modraKuchyn4
            }
          }
        }
      ]
    }
  },
  {
    sys: {
      id: "2"
    },
    fields: {
      name: "kuchyně Kuchyňkových",
      slug: "kuchyne-kuchynkovych",
      type: "kitchen",
      description:
        "Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Curabitur ligula sapien, pulvinar a vestibulum quis, facilisis vel sapien. Fusce wisi. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Etiam sapien elit, consequat eget, tristique non.",
      extras: ["realizace 2017", "použita dýha, lamino", "cena do 250 000 Kč"],
      images: [
        {
          fields: {
            file: {
              url: hnedaKuchyn1
            }
          }
        },
        {
          fields: {
            file: {
              url: hnedaKuchyn2
            }
          }
        }
      ]
    }
  },
  {
    sys: {
      id: "25"
    },
    fields: {
      name: "kuchyně Ledničkových",
      slug: "kuchyne-lednickovych",
      type: "kitchen",
      description:
        "Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Curabitur ligula sapien, pulvinar a vestibulum quis, facilisis vel sapien. Fusce wisi. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Etiam sapien elit, consequat eget, tristique non.",
      extras: ["realizace 2018", "použito lamino, masiv", "cena do 200 000 Kč"],
      images: [
        {
          fields: {
            file: {
              url: modraKuchyn4
            }
          }
        },
        {
          fields: {
            file: {
              url: modraKuchyn2
            }
          }
        },
        {
          fields: {
            file: {
              url: modraKuchyn3
            }
          }
        },
        {
          fields: {
            file: {
              url: modraKuchyn4
            }
          }
        }
      ]
    }
  },
  {
    sys: {
      id: "26"
    },
    fields: {
      name: "kuchyně Ledničkových",
      slug: "kuchyne-lednickovych",
      type: "kitchen",
      description:
        "Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Curabitur ligula sapien, pulvinar a vestibulum quis, facilisis vel sapien. Fusce wisi. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Etiam sapien elit, consequat eget, tristique non.",
      extras: ["realizace 2018", "použito lamino, masiv", "cena do 200 000 Kč"],
      images: [
        {
          fields: {
            file: {
              url: modraKuchyn4
            }
          }
        },
        {
          fields: {
            file: {
              url: modraKuchyn2
            }
          }
        },
        {
          fields: {
            file: {
              url: modraKuchyn3
            }
          }
        },
        {
          fields: {
            file: {
              url: modraKuchyn4
            }
          }
        }
      ]
    }
  },
  {
    sys: {
      id: "29"
    },
    fields: {
      name: "kuchyně Ledničkových",
      slug: "kuchyne-lednickovych",
      type: "kitchen",
      description:
        "Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Curabitur ligula sapien, pulvinar a vestibulum quis, facilisis vel sapien. Fusce wisi. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Etiam sapien elit, consequat eget, tristique non.",
      extras: ["realizace 2018", "použito lamino, masiv", "cena do 200 000 Kč"],
      images: [
        {
          fields: {
            file: {
              url: modraKuchyn4
            }
          }
        },
        {
          fields: {
            file: {
              url: modraKuchyn2
            }
          }
        },
        {
          fields: {
            file: {
              url: modraKuchyn3
            }
          }
        },
        {
          fields: {
            file: {
              url: modraKuchyn4
            }
          }
        }
      ]
    }
  },
  {
    sys: {
      id: "3"
    },
    fields: {
      name: "pokoj",
      slug: "pokoj",
      type: "room",
      description:
        "Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Curabitur ligula sapien, pulvinar a vestibulum quis, facilisis vel sapien. Fusce wisi. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Etiam sapien elit, consequat eget, tristique non.",
      extras: ["realizace 2018", "použito lamino, masiv", "cena do 200 000 Kč"],
      images: [
        {
          fields: {
            file: {
              url: pokoj
            }
          }
        },
        {
          fields: {
            file: {
              url: pokoj2
            }
          }
        },
        {
          fields: {
            file: {
              url: pokoj3
            }
          }
        },
        {
          fields: {
            file: {
              url: modraKuchyn4
            }
          }
        }
      ]
    }
  },
  {
    sys: {
      id: "4"
    },
    fields: {
      name: "restaurace",
      slug: "restaurace-breclav",
      type: "loznice",
      description:
        "Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Curabitur ligula sapien, pulvinar a vestibulum quis, facilisis vel sapien. Fusce wisi. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Etiam sapien elit, consequat eget, tristique non.",
      extras: [
        "realizace 2016",
        "použito lamino, masiv",
        "cena přiližně 450 000 Kč"
      ],
      images: [
        {
          fields: {
            file: {
              url: restaurace
            }
          }
        },
        {
          fields: {
            file: {
              url: restaurace
            }
          }
        },
        {
          fields: {
            file: {
              url: modraKuchyn3
            }
          }
        },
        {
          fields: {
            file: {
              url: modraKuchyn4
            }
          }
        }
      ]
    }
  },
  {
    sys: {
      id: "5"
    },
    fields: {
      name: "Stolek",
      slug: "predsine",
      type: "predsine",
      description:
        "Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Curabitur ligula sapien, pulvinar a vestibulum quis, facilisis vel sapien. Fusce wisi. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Etiam sapien elit, consequat eget, tristique non.",
      extras: ["realizace 2018", "použito lamino, masiv", "cena do 200 000 Kč"],
      images: [
        {
          fields: {
            file: {
              url: stolek
            }
          }
        },
        {
          fields: {
            file: {
              url: stolek
            }
          }
        },
        {
          fields: {
            file: {
              url: modraKuchyn3
            }
          }
        },
        {
          fields: {
            file: {
              url: modraKuchyn4
            }
          }
        }
      ]
    }
  },
  {
    sys: {
      id: "6"
    },
    fields: {
      name: "recepce hotel",
      slug: "recepce-hotel",
      type: "bathroom",
      description:
        "Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Curabitur ligula sapien, pulvinar a vestibulum quis, facilisis vel sapien. Fusce wisi. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Etiam sapien elit, consequat eget, tristique non.",
      extras: ["realizace 2018", "použito lamino, masiv", "cena do 200 000 Kč"],
      images: [
        {
          fields: {
            file: {
              url: recepce
            }
          }
        },
        {
          fields: {
            file: {
              url: recepce
            }
          }
        },
        {
          fields: {
            file: {
              url: modraKuchyn3
            }
          }
        },
        {
          fields: {
            file: {
              url: modraKuchyn4
            }
          }
        }
      ]
    }
  },
  {
    sys: {
      id: "7"
    },
    fields: {
      name: "kancelar",
      slug: "ostatni",
      type: "ostatni",
      description:
        "Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Curabitur ligula sapien, pulvinar a vestibulum quis, facilisis vel sapien. Fusce wisi. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Etiam sapien elit, consequat eget, tristique non.",
      extras: ["realizace 2018", "použito lamino, masiv", "cena do 200 000 Kč"],
      images: [
        {
          fields: {
            file: {
              url: kancelar
            }
          }
        },
        {
          fields: {
            file: {
              url: kancelar
            }
          }
        },
        {
          fields: {
            file: {
              url: modraKuchyn3
            }
          }
        },
        {
          fields: {
            file: {
              url: modraKuchyn4
            }
          }
        }
      ]
    }
  },
  {
    sys: {
      id: "8"
    },
    fields: {
      name: "kuchyně Nováků",
      slug: "single-economy",
      description:
        "Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Curabitur ligula sapien, pulvinar a vestibulum quis, facilisis vel sapien. Fusce wisi. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Etiam sapien elit, consequat eget, tristique non.",
      extras: ["realizace 2018", "použito lamino, masiv", "cena do 200 000 Kč"],
      images: [
        {
          fields: {
            file: {
              url: modraKuchyn1
            }
          }
        },
        {
          fields: {
            file: {
              url: modraKuchyn2
            }
          }
        },
        {
          fields: {
            file: {
              url: modraKuchyn3
            }
          }
        },
        {
          fields: {
            file: {
              url: modraKuchyn4
            }
          }
        }
      ]
    }
  },
  {
    sys: {
      id: "9"
    },
    fields: {
      name: "kuchyně Nováků",
      slug: "single-economy",
      description:
        "Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Curabitur ligula sapien, pulvinar a vestibulum quis, facilisis vel sapien. Fusce wisi. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Etiam sapien elit, consequat eget, tristique non.",
      extras: ["realizace 2018", "použito lamino, masiv", "cena do 200 000 Kč"],
      images: [
        {
          fields: {
            file: {
              url: modraKuchyn1
            }
          }
        },
        {
          fields: {
            file: {
              url: modraKuchyn2
            }
          }
        },
        {
          fields: {
            file: {
              url: modraKuchyn3
            }
          }
        },
        {
          fields: {
            file: {
              url: modraKuchyn4
            }
          }
        }
      ]
    }
  },
  {
    sys: {
      id: "10"
    },
    fields: {
      name: "kuchyně Nováků",
      slug: "single-economy",
      description:
        "Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Curabitur ligula sapien, pulvinar a vestibulum quis, facilisis vel sapien. Fusce wisi. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Etiam sapien elit, consequat eget, tristique non.",
      extras: ["realizace 2018", "použito lamino, masiv", "cena do 200 000 Kč"],
      images: [
        {
          fields: {
            file: {
              url: modraKuchyn1
            }
          }
        },
        {
          fields: {
            file: {
              url: modraKuchyn2
            }
          }
        },
        {
          fields: {
            file: {
              url: modraKuchyn3
            }
          }
        },
        {
          fields: {
            file: {
              url: modraKuchyn4
            }
          }
        }
      ]
    }
  },
  {
    sys: {
      id: "11"
    },
    fields: {
      name: "kuchyně Nováků",
      slug: "single-economy",
      description:
        "Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Curabitur ligula sapien, pulvinar a vestibulum quis, facilisis vel sapien. Fusce wisi. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Etiam sapien elit, consequat eget, tristique non.",
      extras: ["realizace 2018", "použito lamino, masiv", "cena do 200 000 Kč"],
      images: [
        {
          fields: {
            file: {
              url: modraKuchyn1
            }
          }
        },
        {
          fields: {
            file: {
              url: modraKuchyn2
            }
          }
        },
        {
          fields: {
            file: {
              url: modraKuchyn3
            }
          }
        },
        {
          fields: {
            file: {
              url: modraKuchyn4
            }
          }
        }
      ]
    }
  },
  {
    sys: {
      id: "12"
    },
    fields: {
      name: "kuchyně Nováků",
      slug: "single-economy",
      description:
        "Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Curabitur ligula sapien, pulvinar a vestibulum quis, facilisis vel sapien. Fusce wisi. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Etiam sapien elit, consequat eget, tristique non.",
      extras: ["realizace 2018", "použito lamino, masiv", "cena do 200 000 Kč"],
      images: [
        {
          fields: {
            file: {
              url: modraKuchyn1
            }
          }
        },
        {
          fields: {
            file: {
              url: modraKuchyn2
            }
          }
        },
        {
          fields: {
            file: {
              url: modraKuchyn3
            }
          }
        },
        {
          fields: {
            file: {
              url: modraKuchyn4
            }
          }
        }
      ]
    }
  },
  {
    sys: {
      id: "13"
    },
    fields: {
      name: "kuchyně Nováků",
      slug: "single-economy",
      description:
        "Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Curabitur ligula sapien, pulvinar a vestibulum quis, facilisis vel sapien. Fusce wisi. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Etiam sapien elit, consequat eget, tristique non.",
      extras: ["realizace 2018", "použito lamino, masiv", "cena do 200 000 Kč"],
      images: [
        {
          fields: {
            file: {
              url: modraKuchyn1
            }
          }
        },
        {
          fields: {
            file: {
              url: modraKuchyn2
            }
          }
        },
        {
          fields: {
            file: {
              url: modraKuchyn3
            }
          }
        },
        {
          fields: {
            file: {
              url: modraKuchyn4
            }
          }
        }
      ]
    }
  },
  {
    sys: {
      id: "15"
    },
    fields: {
      name: "pokojik",
      slug: "pokojik",
      type: "room",
      description:
        "Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Curabitur ligula sapien, pulvinar a vestibulum quis, facilisis vel sapien. Fusce wisi. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Etiam sapien elit, consequat eget, tristique non.",
      extras: ["realizace 2018", "použito lamino, masiv", "cena do 200 000 Kč"],
      images: [
        {
          fields: {
            file: {
              url: pokoj
            }
          }
        },
        {
          fields: {
            file: {
              url: pokoj
            }
          }
        },
        {
          fields: {
            file: {
              url: modraKuchyn3
            }
          }
        },
        {
          fields: {
            file: {
              url: modraKuchyn4
            }
          }
        }
      ]
    }
  }
];



// WEBPACK FOOTER //
// ./src/data.js